import React from 'react'
import { getValueElement, printKey } from './utils'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Typography from '@mui/material/Typography'
import isEmpty from 'lodash/isEmpty'

const stringifyCompare = (oldData = {}, newData = {}) =>
  JSON.stringify(oldData) !== JSON.stringify(newData);

const TableCompareRowArray = ({ field, oldValues, newValues, action }) => {
  const idsOld = oldValues?.[field]?.map((item) => String(item._id)) || []
  const idsNew = newValues?.[field]?.map((item) => String(item._id)) || []
  const ids = [...idsOld, ...idsNew]
  const uniqueIds = [...new Set(ids)]
  return uniqueIds.map((id, index) => {
    let actionField = 'updated'
    const fields = [];
    const oldItem = oldValues?.[field]?.find((item) => String(item._id) === id) || {}
    const newItem = newValues?.[field]?.find((item) => String(item._id) === id) || {}
    let itemsOld
    let itemsNew
  
    if (isEmpty(oldItem)) {
      actionField = 'created'
    }
    if (isEmpty(newItem)) {
      actionField = 'deleted'
    }
    const mapFields = (key) => {
      if (field === 'growthGoals') {
        if (key === 'question') {
          fields.push(key)
        }
      } else if (field === 'lcs') {
        if (!fields.includes('lcElements')) {
          fields.push('lcElements')
        }
      }
    }

    Object.keys(oldItem)?.forEach(key => {
      if (oldItem[key] !== null && !fields.includes(key)) {
        mapFields(key)
      }
    })

    Object.keys(newItem)?.forEach(key => {
      if (newItem[key] !== null && !fields.includes(key)) {
        mapFields(key)
      }
    })

    if (action.indexOf('granular steps') > -1) {
      itemsOld = [];
      itemsNew = [];
      const oldLevelsIds = oldItem.granularSteps?.map((item) => item.levelId);
      const newLevelsIds = newItem.granularSteps?.map((item) => item.levelId);

      let levelsIds = [...oldLevelsIds, ...newLevelsIds];
      levelsIds = [...new Set(levelsIds)];

      levelsIds.forEach((levelId) => {
        const gsOld = oldItem.granularSteps?.filter((item) => item.levelId === levelId) || [];
        const gsNew = newItem.granularSteps?.filter((item) => item.levelId === levelId) || [];
        if (stringifyCompare(gsOld, gsNew)) {
          itemsOld = [...itemsOld, ...gsOld];
          itemsNew = [...itemsNew, ...gsNew];
        }
      })
    }

    return (
      <>
        <TableRow key={`table-columd-body-${field}-${index}`}>
          <TableCell width={100} className='overflow-hidden'>
            <Typography variant='inherit' className='font-bold text-sm' color='primary'>
              #{index + 1} {printKey(field)}
            </Typography>
            <Typography component={'p'} variant='inherit' className='font-bold text-2xs uppercase' color='primary'>
              {actionField}  
            </Typography>
          </TableCell>
          {fields.map((fieldKey) => (
            <React.Fragment key={`${field}-${fieldKey}`}>
              <TableCell className='overflow-hidden max-w-200px'>
                <Typography variant='inherit' className='text-sm' color='primary'>
                  { fieldKey === 'updated'
                    ? getValueElement(oldItem, fieldKey)
                    : getValueElement(oldItem[fieldKey], fieldKey)
                  }
                  {action.indexOf('granular steps') > -1
                    && fieldKey === 'lcElements'
                    && getValueElement(itemsOld, 'updated-granular-steps')
                  }
                </Typography>
              </TableCell>
              <TableCell className='overflow-hidden max-w-200px'>
                <Typography variant='inherit' className='text-sm' color='primary'>
                  { fieldKey === 'updated'
                    ? getValueElement(newItem, fieldKey)
                    : getValueElement(newItem[fieldKey], fieldKey)
                  }
                  {action.indexOf('granular steps') > -1
                    && fieldKey === 'lcElements'
                    && getValueElement(itemsNew, 'updated-granular-steps')
                  }
                </Typography>
              </TableCell>
            </React.Fragment>
          ))}
        </TableRow>
      </>
    )
  })
}
export default TableCompareRowArray